import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IDropdownSkill } from '../../interfaces/skills/ISkills'
import { useStore } from '../../Provider'
import { MuiButtonVariants, OPButton } from '../OPcomponents/OPButton'
import { OPLoadingCircle } from '../OPcomponents/OPLoadingcircle'
import OPSearch from '../OPcomponents/OPSearch'
import { OPSkillsCombobox } from '../OPcomponents/OPSkillsCombobox'
import { Toast } from '../OPcomponents/Toast'
import '../Profile/myskills.scss'
import '../Profile/profile.scss'
import AddSkill from './AddSkill'
import SkillsTable from './SkillsTable'

const Skills = (): JSX.Element => {
  const { t } = useTranslation()
  const rootStore = useStore()
  const { validatedUser } = rootStore.loginStore
  const {
    getAllSkills,
    loadingSkills,
    showModal,
    showModalHandler,
    setSearchValue,
    setIsSearching,
    isSearching,
    showEditSkillModalHandler,
    clearEditCurrent,
    dropdownCategories,
    getCategories,
    setCategoryFilter,
    allParentSkills,
    setParentFilter,
  } = rootStore.skillStore

  const [selectedCategory, setSelectedCategory] = useState<IDropdownSkill | null>(null)
  const [selectedParent, setSelectedParent] = useState<IDropdownSkill | null>(null)

  useEffect(() => {
    return () => {
      setSearchValue('')
      setIsSearching(false)
      clearEditCurrent()
      showEditSkillModalHandler(false)
      showModalHandler(false)
      // Clear filters when leaving the page
      setSelectedCategory(null)
      setCategoryFilter(null)
      setSelectedParent(null)
      setParentFilter(null)
    }
  }, [clearEditCurrent, setIsSearching, setSearchValue, showEditSkillModalHandler, showModalHandler, setCategoryFilter, setParentFilter])

  useEffect(() => {
    getAllSkills(validatedUser)
    getCategories()
  }, [getAllSkills, getCategories, validatedUser])

  const handleCategoryClear = () => {
    setSelectedCategory(null)
    setCategoryFilter(null)
  }

  const handleCategoryChange = (_e: React.SyntheticEvent, val: IDropdownSkill | null) => {
    setSelectedCategory(val)
    if (val) {
      setCategoryFilter(val.key)
    } else {
      setCategoryFilter(null)
    }
  }

  const handleParentClear = () => {
    setSelectedParent(null)
    setParentFilter(null)
  }

  const handleParentChange = (_e: React.SyntheticEvent, val: IDropdownSkill | null) => {
    setSelectedParent(val)
    if (val) {
      setParentFilter(val.key)
    } else {
      setParentFilter(null)
    }
  }

  return (
    <Grid container rowSpacing={4}>
      <Toast />
      <Grid item xs={12}>
        <p className='profile--titlebigfont'>{t('Navbar.Skills')}</p>
      </Grid>
      <Grid item xs={12} marginTop={'-1rem'}>
        <Grid container alignItems='center' spacing={2}>
          <Grid item xs={12} sm={12} md={4} lg={3} xl={2}>
            <OPSearch
              placeholder={t('Skills.FindSkill')}
              onSearchChange={(val) => {
                setSearchValue(val)
                if (!isSearching) setIsSearching(true)
              }}
              resetValue={() => {
                if (isSearching) setIsSearching(false)
                setSearchValue('')
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <OPSkillsCombobox
              name='categoryFilter'
              optionList={dropdownCategories}
              curState={selectedCategory}
              label={''}
              placeholder={t('Skills.Category')}
              onChange={handleCategoryChange}
              onDelete={handleCategoryClear}
              disableClearable={false}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <OPSkillsCombobox
              name='parentFilter'
              optionList={allParentSkills}
              curState={selectedParent}
              label={''}
              placeholder={t('Skills.ParentSkill')}
              onChange={handleParentChange}
              onDelete={handleParentClear}
              disableClearable={false}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            sx={{ display: 'flex', marginLeft: 'auto', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}
          >
            <OPButton
              label={t('Skills.AddNewSkill')}
              disabled={showModal}
              onClick={showModalHandler}
              buttonVariant={MuiButtonVariants.primary_outlined}
            />
          </Grid>
        </Grid>
      </Grid>

      {showModal && (
        <Grid item xs={12}>
          <AddSkill />
        </Grid>
      )}
      {loadingSkills ? (
        <Grid item xs={12}>
          <OPLoadingCircle />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <SkillsTable />
        </Grid>
      )}
    </Grid>
  )
}

export default observer(Skills)
